import React, { Fragment } from 'react';
import { translate } from '../Services/translation';
import { useSelector } from 'react-redux';

const LanguagePickerNav = ({isMobile}) => {
    const channels = useSelector((state) => state.channels);
    const channelsToUse = channels.channelIsB2B ? channels.channelsB2B : channels.channelsB2C;
    return (
        <Fragment>
            <div className={`language-picker-header ${isMobile ? "mobile" : ""}`}>
                <div className="language-picker-header__item">
                    <input id={`language-header-button${isMobile ? "-mobile" : ""}`} type="checkbox" name="menu" />
                    <label htmlFor={`language-header-button${isMobile ? "-mobile" : ""}`} className={`${isMobile ? "language-header-label-mobile" : ""}`}>
                        <i className="fa-solid fa-globe"></i>{' '}
                        {channelsToUse[0].name}
                        {isMobile &&
                            <i className="navbar__icon--caret-down navbar__icon"></i>
                        }
                    </label>
                    <div className="language-picker-header__submenu">
                        <div className="language-picker-header__table">
                            <div className="language-picker-header__table-items">
                                <div className="language-picker-header__table-items-header">
                                    <div className="language-picker-header__table-items-header-link--active">
                                        {translate(`common.languagepicker.${channels.channelIsB2B ? "b2b" : "b2c"}buttontext`)}
                                    </div>
                                </div>
                                {channelsToUse && channelsToUse.map((data, index) => {
                                    return (
                                        <div
                                            className={`language-picker-header__table-item${data.buyDisabled ? ' global' : ''
                                                }`}
                                            key={`item${data}${index}`}
                                        >
                                            <a
                                                href={data.url}
                                                title={data.name}
                                                className={`language-picker--link ${index === 0 ? 'is-current-website' : ''
                                                    }`}
                                                key={`link${index}`}
                                            >
                                                {data.name} | {data.englishName}
                                            </a>
                                        </div>
                                    );
                                })}
                                <a
                                    href={channels.switchChannelTypeUrl}
                                    className="language-picker-header__table-items-header-link--inactive"
                                >
                                    {translate(`common.languagepicker.goto${channels.channelIsB2B ? "b2c" : "b2b"}`)}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default LanguagePickerNav;
